import { animated, useSpring } from "react-spring";
import { bioPink } from "../../../constants/constants";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

const MenuSubTitle = ({ active, appear, subTitle }) => {
  const { horizontal, h }: any = { ...useWindowSize() };

  const { subTitleHeight } = useSpring({
    from: { subTitleHeight: h(2.5) },
    to: { subTitleHeight: active && !appear ? h(0) : h(2.5) },
  });

  return (
    <animated.div
      style={{
        height: subTitleHeight,
        overflow: "hidden",
        marginTop: horizontal ? "0.5rem" : "1.5rem",
        fontWeight: "900",
      }}
    >
      <animated.div
        style={{
          wordBreak: "break-all",
          fontSize: h(1.5),
          letterSpacing: h(0.9),
          color: bioPink,
          fontWeight: 500,
        }}
      >
        {subTitle}
      </animated.div>
    </animated.div>
  );
};

export default MenuSubTitle;
